import { PopoverPlacement } from "@idui/react-popover";
import { FC, ReactNode } from "react";

import { FramerTooltip } from "@ryde/controls";

interface IDurationLabelBoardingSegmentNormalProps {
  displayContent: string;
  tooltipContent: ReactNode;
}

export const DurationLabelBoardingSegmentNormal: FC<
  IDurationLabelBoardingSegmentNormalProps
> = ({ displayContent, tooltipContent }) => {
  return (
    <FramerTooltip placement={PopoverPlacement.bottom} content={tooltipContent}>
      <label
        data-e2e="ride-boarding-segment-duration"
        className="rideBoardingSegmentDurationLabel"
      >
        {displayContent}
      </label>
    </FramerTooltip>
  );
};
